import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type { GetReportCanvasConfigResponse } from '@erp/rpc';

export function useUserReportCanvasConfig(surfaceId: string) {
  return useQuery(
    orpc.core.userReportCanvasConfigs.get.queryOptions({
      input: { surfaceId },
    }),
  );
}

export function useUpsertUserReportCanvasConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rpcClient.core.userReportCanvasConfigs.upsert,
    onSuccess: (data, variables) => {
      const queryKey = orpc.core.userReportCanvasConfigs.get.queryKey({
        input: { surfaceId: variables.surfaceId },
      });
      queryClient.setQueryData<GetReportCanvasConfigResponse>(queryKey, {
        layout: data.layout,
      });
    },
  });
}

export function useResetUserReportCanvasConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rpcClient.core.userReportCanvasConfigs.reset,
    onSuccess: (_data, variables) => {
      const queryKey = orpc.core.userReportCanvasConfigs.get.queryKey({
        input: { surfaceId: variables.surfaceId },
      });
      // The row is gone; the merged layout falls back to org/developer default.
      queryClient.setQueryData<GetReportCanvasConfigResponse>(queryKey, null);
    },
  });
}
